import { atom } from 'jotai'

export const isSearchEnabledAtom = atom<boolean>(true)

export const isMobileSearchOpenedAtom = atom<boolean>(false)
